module.exports = __webpack_public_path__ + "img/optiplan.f65af52b.png";